import { showNotification } from '@components/notification_box/component_controller';
import copyToClipboard from 'copy-to-clipboard';

export default function copyAndNotify(url, message) {
  const useClipboard = !navigator.share || window.innerWidth > 800; // The navigator.share UX on Desktop devices is terrible

  if (useClipboard) {
    copyToClipboard(url);
    showNotification(message);
  } else {
    navigator.share({ url });
  }
}
